module.exports = __webpack_public_path__ + "img/bg-contact.686463b8.jpg";